<template>
  <th
    :id="hazardId"
    :rowspan="rowspan"
    class="rotated-header cursor-pointer"
    tabindex="0"
    @click="headerClick"
    @keydown.space.prevent="headerClick"
  >
    <div class="d-flex flex-row gap-1 w-100 align-items-center text-truncate rotated-header__content">
      <span>
        {{ columnName || hazardName }}
      </span>

      <v-menu
        offset-x
        nudge-right="10"
        nudge-bottom="20"
      >
        <template #activator="{ on, attrs }">
          <v-icon
            v-bind="attrs"
            v-on="on"
            small
            @click.stop
            :aria-label="`Show hazard details for ${columnName || hazardName}`"
            class="hazard-header__info-icon"
          >
            mdi-information-outline
          </v-icon>
        </template>

        <v-card max-width="40rem">
          <v-card-subtitle class="pb-1">
            {{ hazardName }}
          </v-card-subtitle>

          <v-card-text
            class="overflow-auto"
            style="max-height: 25rem"
          >
            <b-table-lite
              :fields="fields"
              :items="hazardLevels"
              hover
              small
            />
            <div>{{ hazardLevelsComments }}</div>
          </v-card-text>
        </v-card>
      </v-menu>

      <!-- <span>
      {{ columnName || hazardName }}
      <b-icon
        v-show="info"
        :id="`i-${hazardId}`"
        class="help"
        icon="info-circle"
      />
    </span>

    <b-popover
      :delay="delay"
      :target="`i-${hazardId}`"
      :triggers="triggers"
      custom-class="hazard-header-popover"
    >
      <template #title>
        {{ hazardName }}
      </template>
      <b-table-lite
        :fields="fields"
        :items="hazardLevels"
        hover
        small
      />
      <div>{{ hazardLevelsComments }}</div>
    </b-popover> -->
    </div>
  </th>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    hazardId: {
      type: String,
      required: true,
    },
    columnName: {
      type: String,
      default: null,
    },
    rowspan: {
      type: String,
      default: '1',
    },
    headerClick: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      fields: [
        { key: 'source', sortable: true, thClass: 'border-top-0' },
        { key: 'endpoint', thClass: 'border-top-0' },
        { key: 'vh', label: 'VH', thClass: 'border-top-0' },
        { key: 'h', thClass: 'border-top-0' },
        { key: 'm', thClass: 'border-top-0' },
        { key: 'l', thClass: 'border-top-0' },
      ],
    }
  },

  computed: {
    ...mapGetters(['getHazardEndpoints', 'getHazardLevels']),
    hazardName: function () {
      return this.getHazardEndpoints?.find((c) => c.id === this.hazardId).name
    },
    hazardLevels: function () {
      return this.getHazardLevels?.find((c) => c.categoryId === this.hazardId).sources
    },
    hazardLevelsComments: function () {
      return this.getHazardLevels?.find((c) => c.categoryId === this.hazardId).comments
    },
  },
}
</script>

<style scoped>
.rotated-header {
  height: 10rem;
  width: 4rem;
  padding: 0.2rem;
  vertical-align: middle !important; /* center in row, not bottom */
}

.rotated-header__content {
  writing-mode: sideways-lr;
}

.hazard-header__info-icon:hover {
  color: rgba(0, 0, 0, 1) !important;
}
</style>
